<div class="container">
  <div>

  </div>
  <div class="cardBox mb-20">


    <ion-row>
      <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="ml-20 mt-20">
        <mat-form-field class="mat-height40 mat-input-style">
          <mat-icon matPrefix>search</mat-icon>
          <input matInput type="search" placeholder="Search" [(ngModel)]="searchTerm" (input)="filterEmployees()">

        </mat-form-field>
      </ion-col>
      <ion-col class="mt-20">
        <label>
          <ion-label class="fs-14 font_regular pr-10 black_color ml-10 ">Show</ion-label>
          <mat-form-field class="w70px mat-height40 mat-input-style">
            <mat-select placeholder="Select" placeholder="Select" (selectionChange)="DislaySelectedRecord($event)">
              <mat-option [value]="2">2</mat-option>
              <mat-option [value]="25">25</mat-option>
              <mat-option [value]="50">50</mat-option>
              <mat-option [value]="75">75</mat-option>
              <mat-option [value]="100">100</mat-option>
            </mat-select>
          </mat-form-field>
          <ion-label class="fs-14 font_regular pl-10 black_color">entries</ion-label>
        </label>
      </ion-col>


      <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3">
        <div class="d-flex justify-content-flex-end ">
          <div class="d-flex" style="margin-right: 15px; margin-top: 10px;" (click)="downloadCSV()">
            <span class="ml-5 mr-5 icon-download fs-20 material-icons">download</span>
          </div>
        </div>
      </ion-col>
    </ion-row>
    <div class="p-10">
      <ion-row>
        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
          <div class="table-container">
            <table>
         
              <thead>
                <tr>

                  <th *ngFor="let item of OfferAndAppointmentTableHeader" class="fs-14 font_bold cl-black">
                    <div class="p-5 verticle-center justify-content-space-between icon-style" style="width: 90px;">
                      {{ item?.label }}

                    </div>
                  </th>
                </tr>
              </thead>
        
              <tbody>
                <tr *ngFor="let employee of employeesProbationDetails; let i = index">
                  <!-- Sr. No -->
                  <td>{{ i + 1 }}</td>
                  <td>{{ employee.emplCode }}</td>
                  <td>{{ employee.empName }}</td>
                  <td>{{ employee.empDept }}</td>
                  <td>{{ employee.band}}</td>
                  <td>{{ employee.grade }}</td>
                  <td>{{ employee.dateOfJoining | date: 'dd-MM-yyyy'}}</td>


                  <td>{{ employee.dateOfConfirmation | date: 'dd-MM-yyyy' }}</td>
                  <td *ngIf="loggedInUserRole!=='HOD' && loggedInUserRole!=='Manager'&&loggedInUserRole!=='Employee'">
                    <mat-form-field class="w-90 mat-height40 mat-input-style" (click)="confirmationpopp(employee)">
                      <mat-select placeholder="select probation " (ngModelChange)="getprobationData(employee)"[(ngModel)]="employee.probationStatus"(selectionChange)="onProbationChange(employee)"
                        [disabled]="(loggedInUserRole=='HOD'||loggedInUserRole=='Manager'||loggedInUserRole=='Employee') && !isEditable(employee)">
                        <mat-option [value]="'Confirmation'" [disabled]="!confirmationFlag">
                          Confirm
                        </mat-option>
                        <mat-option [value]="'Extension'">
                          Extension
                        </mat-option>

                      </mat-select>
                    </mat-form-field>
                  </td>
                  <td *ngIf="!(loggedInUserRole === 'HR Admin' || loggedInUserRole === 'Super Admin' || loggedInUserRole === 'PHI Admin' || loggedInUserRole === 'MD')">
                    {{employee.probationStatus}}
                  </td>
                  <td> {{employee.probationExtensionByDay}}</td>
                  <td>
                    <!-- [disabled]="(loggedInUserRole=='HOD'||loggedInUserRole=='Manager')&& !isEditable(employee)" -->
                    <textarea rows="2" cols="4" class="edittextarea" [(ngModel)]="employee.reasonForExtension"
                    [disabled]="!(loggedInUserRole === 'HR Admin' || loggedInUserRole === 'Super Admin' || loggedInUserRole === 'PHI Admin' || loggedInUserRole === 'MD')"
                      maxlength="255" (ngModelChange)="getprobationData(employee)"
                      [ngModelOptions]="{standalone: true}"></textarea>
                  </td>
                  <td *ngIf="(loggedInUserRole === 'HR Admin' || loggedInUserRole === 'Super Admin' || loggedInUserRole === 'PHI Admin' || loggedInUserRole === 'MD')"> <mat-form-field class="w-90 mat-height40 mat-input-style">
                      <mat-select placeholder="select probation" (ngModelChange)="getprobationData(employee)"
                        [(ngModel)]="employee.changesPostConfirmation"
                        [disabled]="employee.probationStatus !=='Confirmation'">
                        <mat-option [value]="'No_Change'">
                          No Change
                        </mat-option>
                        <mat-option [value]="'Change_Needed'" (click)="onClickOpenChangeNeededPopup(employee.userId)">
                          Change Needed
                        </mat-option>

                      </mat-select>
                    </mat-form-field></td>
                  <td>
                    <!-- <div class="d-flex">

                      <img src="././assets/icon/blueEyeIcon.svg" matTooltip=" Recommended By {{employee.recommendedBy}}" class="cp"
                       *ngIf="loggedInUserRole=='HR Admin' && employee.matchuser" (click)="changedFromHODORManager(employee.userId,employee.recommendedBy)">
                      <button type="button" class="add_btn fs-14 float-right center-content mr-5 custom-disabled-button"
                        [style.background-color]="buttonColorName" [disabled]="(employee.probationStatus!==null || employee.probationStatus!=='')&&loggedInUserRole!=='HR Admin'"
                        (click)="loggedInUserRole=='HR Admin'? SaveProbationData(employee.userId):changedFromHODORManager(employee.userId,null)" >
                        {{loggedInUserRole=='HR Admin'?'Save':'Edit By'+loggedInUserRole}}</button>
                    </div> -->
                    <div class="d-flex align-items-center justify-content-start">
                      <img src="././assets/icon/blueEyeIcon.svg" 
                           matTooltip="Recommended By {{employee.recommendedBy}}" 
                           class="cp mr-2"
                           [style.visibility]="((loggedInUserRole === 'HR Admin' || loggedInUserRole === 'Super Admin' || loggedInUserRole === 'PHI Admin' || loggedInUserRole === 'MD') && employee.matchuser) ? 'visible' : 'hidden'"
                           (click)="changedFromHODORManager(employee.userId,employee.recommendedBy,employee.probationCurrentLogUserType)">
                  
                           <button type="button" class="add_btn fs-14 custom-disabled-button"
                           [ngStyle]="{'background-color': buttonColorName}"
                           [disabled]="employee.probationStatus && !(loggedInUserRole === 'HR Admin' || loggedInUserRole === 'Super Admin' || loggedInUserRole === 'PHI Admin' || loggedInUserRole === 'MD')"
                           (click)="(loggedInUserRole === 'HR Admin' || loggedInUserRole === 'Super Admin' || loggedInUserRole === 'PHI Admin' || loggedInUserRole === 'MD') ? SaveProbationData(employee.userId) : changedFromHODORManager(employee.userId, null, null)">
                     {{ (loggedInUserRole === 'HR Admin' || loggedInUserRole === 'Super Admin' || loggedInUserRole === 'PHI Admin' || loggedInUserRole === 'MD') ? 'Save' : 'Edit By ' + loggedInUserRole }}
                   </button>
                   
                    </div>
                    
                    
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </ion-col>
      </ion-row>
    </div>
  </div>
</div>